import script from "./ToggleSN.vue?vue&type=script&setup=true&lang=js"
export * from "./ToggleSN.vue?vue&type=script&setup=true&lang=js"

import "./ToggleSN.vue?vue&type=style&index=0&id=410aa0ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-410aa0ca"]])

export default __exports__